import React, { ReactNode } from 'react';
import { ArticleBlockContentGridCol } from '../types/components/ArticleBlockContentGridCol/ArticleBlockContentGridCol';

interface ArticleWrapperProps {
  children?: ReactNode;
  styleName: string;
  isArticle: boolean;
}

export const ArticleWrapper = ({ children, styleName, isArticle }: ArticleWrapperProps) =>
  isArticle ? (
    <ArticleBlockContentGridCol className={`article_${styleName}`}>{children}</ArticleBlockContentGridCol>
  ) : (
    children
  );
